<div [class.suggested-courses--padding]="isShowPadding" class="o-flex o-flex--column" *ngIf="suggestedCourses">
  <p class="suggested-courses__heading">{{title}}</p>
  <swiper [config]="configSwiper">
    <ng-template swiperSlide *ngFor="let course of suggestedCourses">
      <app-card-course-catalog [course]="course"></app-card-course-catalog>
    </ng-template>
  </swiper>
</div>
